module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-pic-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user-pic-bg",
    on: {
      "click": _vm.imgBtnClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImg),
      expression: "showImg"
    }],
    ref: "img",
    staticClass: "user-pic",
    attrs: {
      "src": _vm.pic
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "user-pic-tit"
  }, [_vm._v("头像，一个好工作的开始")]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showSelectBox),
      callback: function($$v) {
        _vm.showSelectBox = $$v
      },
      expression: "showSelectBox"
    }
  }, [_c('selext-box', {
    on: {
      "hidePop": _vm.hidePop,
      "chooseImg": _vm.chooseImg,
      "choose58pic": _vm.choose58pic,
      "imgSelect": _vm.imgSelect
    },
    model: {
      value: (_vm.showSelectBox),
      callback: function($$v) {
        _vm.showSelectBox = $$v
      },
      expression: "showSelectBox"
    }
  })], 1), _vm._v(" "), _c('preview', {
    attrs: {
      "imgSrc": _vm.pic
    },
    on: {
      "changImg": _vm.changImg
    },
    model: {
      value: (_vm.showPreview),
      callback: function($$v) {
        _vm.showPreview = $$v
      },
      expression: "showPreview"
    }
  }), _vm._v(" "), _c('cut-img', {
    attrs: {
      "dataUrl": _vm.dataUrl
    },
    on: {
      "afterCrop": _vm.submit,
      "chooseOther": _vm.chooseOther
    },
    model: {
      value: (_vm.showCutBox),
      callback: function($$v) {
        _vm.showCutBox = $$v
      },
      expression: "showCutBox"
    }
  }), _vm._v(" "), _c('toast', {
    attrs: {
      "time": _vm.time
    },
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_vm._v(_vm._s(_vm.toastTip))]), _vm._v(" "), _c('loading', {
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-pic-wrap"
  }, [_c('div', {
    staticClass: "user-pic-content"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a29947c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/headPortrait/index.vue
// module id = 369
// module chunks = 0